import { FilterDateInterface } from '@sixense/ds-filters-models';
import { DocFilterContentInterface } from '../interfaces/doc-filter-content.interface';
import { VisaStatesEnum } from '../enums/visa-states.enum';

export class DocFilterContentModel {
  /**
   *
   */
  public nameContains: string;

  /**
   *
   */
  public creationDate: FilterDateInterface = {};

  /**
   *
   */
  public tags: string[];

  /**
   *
   */
  public creatorEmail: string;

  /**
   *
   */
  public visaStatus: string;

  /**
   *
   */
  public dueDate: FilterDateInterface = {};

  /**
   * Creates an instance of DsDocFilter.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DocFilterContentInterface) {
    this.nameContains = jsonData?.name__contains || '';
    this.creationDate.begin = jsonData?.created_after ? new Date(jsonData?.created_after) : null;
    this.creationDate.end = jsonData?.created_before ? new Date(jsonData?.created_before) : null;
    this.tags =
      jsonData && typeof jsonData.tags === 'string' ? jsonData.tags.split(',').map((item) => item.trim()) : [];
    this.creatorEmail = jsonData?.creator_email || '';
    this.visaStatus = jsonData?.visa__status || jsonData?.visa__status__strict;
    if (jsonData?.has__visa === 'false') {
      this.visaStatus = VisaStatesEnum.NO_VISA;
    }
    if (jsonData?.visa__past__deadline === true) this.visaStatus = VisaStatesEnum.LATE;
    this.dueDate.begin = jsonData?.visa__deadline_after ? new Date(jsonData?.visa__deadline_after) : null;
    this.dueDate.end = jsonData?.visa__deadline_before ? new Date(jsonData?.visa__deadline_before) : null;
  }
}
